"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardFooter = exports.CardContent = exports.CardDescription = exports.CardTitle = exports.CardHeader = exports.Card = void 0;
const react_1 = __importDefault(require("react"));
const utils_1 = require("../utils");
// Card component that acts as a container for card sections
const Card = ({ children, className, onClick, }) => {
    return (react_1.default.createElement("div", { className: (0, utils_1.cn)("bg-brandWhite shadow-md rounded-lg overflow-hidden", className), onClick: onClick }, children));
};
exports.Card = Card;
// CardHeader component for the header section of the card
const CardHeader = ({ children, className, }) => {
    return react_1.default.createElement("div", { className: (0, utils_1.cn)("p-4 border-b", className) }, children);
};
exports.CardHeader = CardHeader;
// CardTitle component for the title in the header
const CardTitle = ({ children, className, }) => {
    return react_1.default.createElement("h2", { className: (0, utils_1.cn)("text-xl font-semibold text-grey800", className) }, children);
};
exports.CardTitle = CardTitle;
// CardDescription component for the description in the header
const CardDescription = ({ children, className, }) => {
    return react_1.default.createElement("p", { className: (0, utils_1.cn)("text-sm text-grey600", className) }, children);
};
exports.CardDescription = CardDescription;
// CardContent component for the main content area of the card
const CardContent = ({ children, className = "", }) => {
    return react_1.default.createElement("div", { className: (0, utils_1.cn)("p-4", className) }, children);
};
exports.CardContent = CardContent;
// CardFooter component for the footer section of the card
const CardFooter = ({ children, className, }) => {
    return react_1.default.createElement("div", { className: (0, utils_1.cn)("p-4 border-t", className) }, children);
};
exports.CardFooter = CardFooter;
